import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPigletStables, setPigletStablesAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PIGLET_STABLES } from "consts";

import { FootprintingPigletStablesPayload } from "models";

export const useMutateFootprintingPigletStables = (farmId: string, year: number, payload: FootprintingPigletStablesPayload, primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_PIGLET_STABLES, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setPigletStablesAdmin(payload, primaryDataId) : setPigletStables(payload, primaryDataId)),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_PIGLET_STABLES, primaryDataId, isAdmin],
        ...footprintingPigletPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
